import React from 'react';

import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import SwitchComponent from 'components/common/Switch/Switch';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';

import { IComponentKey } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { settingsConfig } from 'components/Settings/settingsConfig';

import classes from './narrativeCustomButtons.module.scss';

interface Props {
    isAdmin: boolean;
    componentKey: IComponentKey | undefined;
    isGenerativeAi: boolean | undefined;
    setIsGenerativeAi(value: boolean): void;
}

export const NarrativeCustomButtons = ({ isAdmin, isGenerativeAi, setIsGenerativeAi, componentKey }: Props) => {
    const linkToNarrativeTemplateEditor = () => {
        const query = {
            componentKey: componentKey ?? 'component-not-found',
        };

        return AppRoutes.buildPathWithQuery([AppRoutes.SETTINGS, settingsConfig.narrativeTemplates.link], query);
    };

    return (
        <div className={classes.customToolbarButtonsWrapper}>
            {isAdmin && (
                <div className={classes.editNarrativeTemplateLinkWrapper}>
                    <Link to={linkToNarrativeTemplateEditor()}>Edit Narrative Template</Link>
                </div>
            )}
            <div className={classes.switchWrapper}>
                <div className={classes.switchTitle}>
                    <MuiIcon icon="auto_awesome_icon" fontSize="2rem" color="#2C8FA5" />
                    Use Automated Narrative
                </div>
                <SwitchComponent onChange={() => setIsGenerativeAi(!isGenerativeAi)} checked={isGenerativeAi} />
            </div>
        </div>
    );
};
